@if (showHeading) {
  <page-heading
    [title]="'channel.settingsTemplateList.title' | translate"
    [description]="'channel.settingsTemplateList.description' | translate"
  />
}

<!-- Filters live in their own card above the table, as on the user and quick-reply lists. -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <!-- Narrowed from xl-4 to xl-2: six blocks of two would push this row past the 12-column
               grid and wrap the last button onto a line of its own. -->
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2 input-trend-search"
          >
            <input
              type="search"
              class="form-control"
              [formControl]="searchControl"
              [placeholder]="
                'channel.settingsTemplateList.searchPlaceholder' | translate
              "
            />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>

          <div
            class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2 btn-group trend-button"
          >
            <button
              type="submit"
              [matMenuTriggerFor]="statusMenu"
              class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
            >
              <span>
                {{
                  selectedStatus
                    ? translateTemplateStatus(selectedStatus)
                    : ("channel.settingsTemplateList.status" | translate)
                }}
              </span>
            </button>
          </div>

          <div
            class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2 btn-group trend-button"
          >
            <button
              type="submit"
              [matMenuTriggerFor]="categoryMenu"
              class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
            >
              <span>
                {{
                  selectedCategory
                    ? translateTemplateCategory(selectedCategory)
                    : ("channel.settingsTemplateList.category" | translate)
                }}
              </span>
            </button>
          </div>

          <div
            class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2 btn-group trend-button"
          >
            <button
              type="button"
              class="btn btn-primary fw-bold"
              (click)="cleanCacheTemplates()"
            >
              {{ "channel.settingsTemplateList.refresh" | translate }}
            </button>
          </div>

          <div
            class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2 btn-group trend-button"
          >
            <button
              type="button"
              class="btn btn-success fw-bold"
              (click)="newTemplate()"
            >
              {{ "channel.settingsTemplateList.newTemplate" | translate }}
            </button>
          </div>

          <!-- DEV-1992 — the Payments API template cannot be built in Meta's own composer, so this
               is the only place it can be created. Soft green to read as a sibling of "Novo
               template" rather than of the blue filters. -->
          <div
            class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2 btn-group trend-button"
          >
            <button
              type="button"
              class="btn btn-soft-success fw-bold"
              (click)="newPixTemplate()"
              [matTooltip]="
                'channel.settingsTemplateList.newPixTemplateHelp' | translate
              "
            >
              {{ "channel.settingsTemplateList.newPixTemplate" | translate }}
            </button>
          </div>

          <mat-menu #statusMenu="matMenu">
            <button mat-menu-item (click)="filterByStatus('')">
              {{ "channel.settingsTemplateList.all" | translate }}
            </button>
            @for (status of statuses; track status.value) {
              <button mat-menu-item (click)="filterByStatus(status.value)">
                {{ status.label | translate }}
              </button>
            }
          </mat-menu>

          <mat-menu #categoryMenu="matMenu">
            <button mat-menu-item (click)="filterByCategory('')">
              {{ "channel.settingsTemplateList.all" | translate }}
            </button>
            @for (category of categories; track category.value) {
              <button mat-menu-item (click)="filterByCategory(category.value)">
                {{ category.label | translate }}
              </button>
            }
          </mat-menu>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card">
  @if (loadingContent) {
    <content-loading-list />
  }

  @if (!loadingContent && pager.total > 0) {
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">
              {{ "channel.settingsTemplateList.columnTemplate" | translate }}
            </th>
            <th class="text-primary-emphasis">
              {{ "channel.settingsTemplateList.columnStatus" | translate }}
            </th>
            <th class="text-primary-emphasis">
              {{ "channel.settingsTemplateList.columnCategory" | translate }}
            </th>
            <th class="text-primary-emphasis">
              {{ "channel.settingsTemplateList.columnLanguage" | translate }}
            </th>
            <th>
              <span class="sr-only"></span>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (template of pager.list; track template.id) {
            <tr>
              <td>
                <strong>{{ template.name }}</strong
                ><br />
                <span class="text-muted" [matTooltip]="getBodyText(template)">
                  {{ getBodyText(template) | slice: 0 : 80 }}
                </span>
              </td>
              <td>
                <span
                  class="badge text-capitalize font-14"
                  [ngClass]="statusBadgeClass(template.status)"
                >
                  {{ translateTemplateStatus(template.status) }}
                </span>
              </td>
              <td>{{ translateTemplateCategory(template.category) }}</td>
              <td>
                @if (languageFlag(template.language)) {
                  <span class="d-flex align-items-center gap-2">
                    <img
                      width="20"
                      [src]="languageFlag(template.language)"
                      [matTooltip]="template.language"
                    />
                  </span>
                } @else {
                  {{ template.language }}
                }
              </td>
              <td>
                <div class="d-flex justify-content-end">
                  <button
                    class="btn btn-dropdown-list"
                    [matMenuTriggerFor]="rowMenu"
                    type="button"
                  >
                    <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                  </button>
                  <mat-menu #rowMenu="matMenu">
                    @if (canEditNow(template)) {
                      <button
                        mat-menu-item
                        tabindex="0"
                        (click)="editTemplate(template)"
                      >
                        {{ "channel.settingsTemplateList.edit" | translate }}
                      </button>
                    }

                    @if (isPaused(template)) {
                      <button
                        mat-menu-item
                        tabindex="0"
                        (click)="unpauseTemplate(template)"
                      >
                        {{ "channel.settingsTemplateList.unpause" | translate }}
                      </button>
                    }

                    @if (!isBeingRemoved(template)) {
                      <button
                        mat-menu-item
                        tabindex="0"
                        (click)="removeTemplate(template)"
                      >
                        {{ "channel.settingsTemplateList.remove" | translate }}
                      </button>
                    }
                  </mat-menu>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (pager.total > pager.perPage) {
        <paginator [pager]="pager" (onPager)="loadPage($event)" />
      }
    </div>
  } @else if (!loadingContent) {
    <empty-records-component
      [message]="'channel.settingsTemplateList.noTemplatesFound' | translate"
      [icon]="'mdi mdi-alert-circle-outline'"
      [subMessage]="
        'channel.settingsTemplateList.noTemplatesFoundSubMessage' | translate
      "
      [buttonClass]="'btn btn-info fw-bold'"
      [labelButton]="'channel.settingsTemplateList.newTemplate' | translate"
      (emitEvent)="newTemplate()"
    />
  }
</div>
